import memoize from 'lodash/memoize';
import { Validator } from 'redux-form';

export const maxFileSize = memoize(
  (message: string, maxSizeInBytes: number): Validator =>
    (value: File | undefined | null) => {
      if (!value || !(value instanceof File)) {
        return undefined;
      }

      return value.size > maxSizeInBytes ? message : undefined;
    },
  (message, maxSizeInBytes) => `${message}_${maxSizeInBytes}`,
);
